const Proyects = {
    'data': [
        {
            'id': 1,
            'img': 'https://i.ibb.co/FB5DqBN/burger-Kawaii-App-Talento.png',
            'name': 'Burger Kawaii',
            'description': 'It\'s a web app to be use in tablets. It creates orders to a burger restaurant with two menus where the chefs can see the orders in real time and delete them when they are ready.',
            'demo': 'https://vimeo.com/376056295',
            'github': 'https://github.com/PaulinaMontoya/burger-kawaii',
            'technologies': ["React.js", "Create-React-App", "React-Router", "CSS3", "HTML5", "Responsive Web", "Fetch"]
        },
        {
            'id': 2,
            'img': 'https://i.ibb.co/0KzpMNS/guanataco-App-Talento.png',
            'name': 'Guanataco',
            'description': 'It\'s a social network to write posts with comments about places to eat tacos in the city of Guadalajara and other users can rate them.',
            'demo': 'https://vimeo.com/376266190',
            'github': 'https://github.com/PaulinaMontoya/GDL003-social-network',
            'technologies': ["Vanilla-JavaScript", "CSS3", "HTML5", "Firebase-Authentication", "Cloud Firestore"]
        },
        {
            'id': 3,
            'img': 'https://i.ibb.co/0V2QX5y/morty-App-Talento.png',
            'name': 'Morty\'s Nightmares',
            'description': 'It\'s a 2D platform game created with Unity. If you want to dowloand it the build is in my GitHub account but it only works in windows.',
            'demo': 'https://vimeo.com/376002772',
            'github': 'https://github.com/PaulinaMontoya/GDL003-Videogame-2D-Rick-and-Morty',
            'technologies': ["Unity", "C#"]
        }
    ]
}

export default Proyects